import { useEffect, useState } from "react";

/**
 * SmartImage
 * -----------------------------------------------------------
 * Drop-in <img> with an elegant placeholder when the file is
 * missing or fails to load. Fills its parent's width and keeps
 * the given aspect ratio ("4/5", "4/3", ...). Pass rounding via
 * className (e.g. "rounded-2xl").
 */
export default function SmartImage({ src, alt = "", className = "", label, aspect = "4/5" }) {
  const [failed, setFailed] = useState(!src);

  useEffect(() => {
    setFailed(!src);
  }, [src]);

  const [w, h] = String(aspect).split("/").map(Number);
  const style = { aspectRatio: `${w} / ${h || 1}` };

  if (failed) {
    return (
      <div
        role="img"
        aria-label={alt || label}
        style={style}
        className={`relative w-full overflow-hidden bg-bone flex flex-col items-center justify-center gap-3 ${className}`}
      >
        <div className="absolute inset-3 border border-gold/60 rounded-[inherit] pointer-events-none" />
        <svg width="34" height="34" viewBox="0 0 40 40" fill="none" stroke="#C9A961" strokeWidth="1.2" aria-hidden="true">
          <path d="M20 8 C 24 14 24 22 20 28 C 16 22 16 14 20 8 Z" />
          <path d="M20 28 C 12 26 8 20 7 14 C 14 15 18 20 20 28 Z" />
          <path d="M20 28 C 28 26 32 20 33 14 C 26 15 22 20 20 28 Z" />
          <path d="M14 33 H 26" />
        </svg>
        {label && (
          <span className="px-6 text-center font-display italic text-lg text-rani/70">{label}</span>
        )}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      style={style}
      onError={() => setFailed(true)}
      className={`w-full object-cover ${className}`}
    />
  );
}
